import { Pipe, PipeTransform } from '@angular/core';
import { TauxReconnaissance } from '../../models/tauxReconnaissance';

@Pipe({
	name: 'filterTauxReconnaissanceByName'
})
export class FilterTauxReconnaissanceByNamePipe implements PipeTransform {
	transform(tauxReconnaissance: TauxReconnaissance[], filter: string): TauxReconnaissance[] {
		if (
			!tauxReconnaissance ||
			!filter ||
			tauxReconnaissance === null ||
			filter === null ||
			filter === ''
		) {
			return tauxReconnaissance;
		}

		return tauxReconnaissance.filter((tauxReconnaissance: TauxReconnaissance) => {
			if (tauxReconnaissance.name) {
				// TODO: add lastName too
				return tauxReconnaissance.name.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
